/**
 * @bos/portal3 — the unauthenticated entry shell (sign in / register).
 *
 * A minimal, branded sign-in experience — deliberately NOT a marketing/sales landing
 * page (that lives on the corporate site, www.sorvel.eu). It centers the Sorvel seal
 * over a single calm card (the routed login/register form renders into the <Outlet/>),
 * with one short trust line and a small "Learn more" link out to the corporate site.
 */
import { Outlet } from 'react-router-dom';
import { Brand } from './components/Brand';

/** The corporate site — a SEPARATE deliverable; this is the only outbound marketing link. */
const CORPORATE_URL = 'https://www.sorvel.eu';

export function AuthLayout() {
  return (
    <div className="authpage">
      <div className="authpage__inner">
        <div className="authpage__brand">
          <Brand size="lg" />
        </div>

        <Outlet />

        <div className="authpage__foot">
          <p className="authpage__trust">
            Private by design — your projects and documents are yours alone.
          </p>
          <a
            className="authpage__learn"
            href={CORPORATE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            New to Sorvel? Learn more →
          </a>
        </div>
      </div>
    </div>
  );
}
